<template>
    <footer>
        <div class="container-fluid footer-bg pt-4">
            <div class="container footer-content">
                <div class="row justify-content-between">
                    <div class="col-6 widget-3">
                        <h4>Sections</h4>
                        <ul>
                            <li><router-link to="/our-services/">Our Services</router-link></li>
                            <li><router-link to="/why-use-us/">Why Use Us</router-link></li>
                            <li><router-link to="/testimonials/">Testimonials</router-link></li>
                            <li><router-link to="/contact-us/">Contact Us</router-link></li>
                            <li><router-link to="/privacy-policy/">Privacy Policy</router-link></li>
                            <li><router-link to="/terms-and-conditions/">Terms and Conditions</router-link></li>
                        </ul>
                    </div>
                    <div class="col-6 widget-2">
                        <h4>Contact Us</h4>
                        <p>Harling Taxis</p>
                        <p>Email: <a href="mailto:enquiries@harling-taxis.co.uk">enquiries@harling-taxis.co.uk</a></p>
                        <p>Tel: <a href="tel:07950189260">07950 189 260</a></p>
                        <div class="row social-icons no-gutters mt-2">
                            <div class="col-auto mr-1"><a target="_blank" href="https://en-gb.facebook.com/HarlingTaxis/"><img src="../../assets/images/facebook.png" alt="facebook"></a></div>
                            <div class="col-auto ml-1"><a target="_blank" href="https://twitter.com/harling_taxis"><img src="../../assets/images/twitter.png" alt="twitter"></a></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 footer-copy">
                <p>Copyright &copy; Harling Taxis. All Rights Reserved. {{date()}}. - <a href="#">Sitemap</a></p>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'main-footer',
  methods: {
    date () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/partials/MainFooter.vue